import { render, staticRenderFns } from "./BadgeModule.vue?vue&type=template&id=f293b988&scoped=true&"
import script from "./BadgeModule.vue?vue&type=script&lang=js&"
export * from "./BadgeModule.vue?vue&type=script&lang=js&"
import style0 from "./BadgeModule.vue?vue&type=style&index=0&id=f293b988&lang=scss&scoped=true&"
import style1 from "./BadgeModule.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f293b988",
  null
  
)

export default component.exports